
const hiddenModals = new Map();

export const hideOpenModalsForPrint = (root = document) => {
    root.querySelectorAll('.modal.show').forEach((modal) => {
        const display = modal.style.getPropertyValue('display');

        if (display !== 'block') {
            return;
        }

        hiddenModals.set(modal, display);
        modal.style.removeProperty('display');
    });
};

export const restoreModalsAfterPrint = () => {
    hiddenModals.forEach((display, modal) => {
        if (modal.isConnected && modal.classList.contains('show')) {
            modal.style.setProperty('display', display);
        }
    });

    hiddenModals.clear();
};

export const registerPrintModalReset = (target = window) => {
    target.addEventListener('beforeprint', hideOpenModalsForPrint);
    target.addEventListener('afterprint', restoreModalsAfterPrint);
};
